import {Injectable} from '@angular/core';
import {SessionService} from '../../../shared/session-service/session.service';
import {API_URL} from '../../../shared/constants/apiurl-constants';
import { EmailDefaultCcDto, UseAsAutoReminderEmailDto} from '../../models/email';

@Injectable({providedIn: 'root'})
export class EmailService {
  constructor(private _sessionService: SessionService) {}

  GetSMEEmailModifyTemplate(templateRequest){
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.GET_SME_EMAIL_TEMPLATE,templateRequest,
    );
  }

  sendEmailToSme(SendEmailRequest, isWelcomeEmailSent){
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.SEND_EMAIL_TOSME + '?isWelcomeEmailSent=' + isWelcomeEmailSent,
      SendEmailRequest,
    ); 
  }
  saveCustomEmailTemplate(SendEmailRequest){
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.SAVE_CUSTOM_EMAIL_TEMPLATE ,
      SendEmailRequest
    ); 
  }
  GetCustomEmailTemplate(engagementId, templateId){
    return this._sessionService.apiUrlGet(
      API_URL.SURVEY.GET_CUSTOM_EMAIL_TEMPLATE +
        '?engagementId=' +
        engagementId +
        '&templateId=' +
        templateId,
    );
  }
  deleteCustomEmailTemplate(SendEmailRequest){
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.DELETE_CUSTOM_EMAIL_TEMPLATE ,
      SendEmailRequest
    ); 
  }

  useAsAutoReminderEmail(useAsAuto: UseAsAutoReminderEmailDto) {
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.USE_AS_AUTOREMINDER, useAsAuto);
  }

  updateEmailDefaultCc(emailDefaultCcDto: EmailDefaultCcDto) {
    return this._sessionService.apiUrlPost(
      API_URL.SURVEY.UPDATE_EMAIL_DEFAULT_CC, emailDefaultCcDto); 
  }
}
